/**
 * Internal dependencies
 */
import { initFancybox, initMegaMenu, initScrollDetector, throttle } from './js';

window.addEventListener('load', function () {
	// Make sure we don't load these in the backend wp-admin and block-editor-iframe__body.
	if (
		document.body.classList.contains('wp-admin') ||
		document.body.classList.contains('block-editor-iframe__body')
	) {
		return;
	}

	initFancybox();
	initMegaMenu();
	window.addEventListener('scroll', throttle(initScrollDetector, 20));
});
